<wl-card heading="BRE Status">
    <wl-label label="Status" [value]="status?.toUpperCase()"></wl-label>
 </wl-card>